import React from "react";
import { connectWithLifecycle } from "react-lifecycle-component";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import {
  setDailyReportDate,
  setDailyReportProduct,
  setDailyReportVariation
} from "../../redux/modules/uiDuck";
import moment from "moment";
import { fromJS } from "immutable";

import {
  getOrdersAmountByHour,
  getDailyReportDate,
  getProductsMap,
  getDailyReportProduct,
  getDailyReportVariation
} from "../../redux/selectors";
import OrdersByDayBarChart from "../presentational/OrdersByDayBarChart";
import OrderLineProcessingTimeByDayChart from "../presentational/OrderLineProcessingTimeByDayChart";
import DailyReportTable from "../presentational/DailyReportTable";
const savedDateFormat = "DD/MM/YYYY";
const margin = { top: 20, right: 20, bottom: 30, left: 40 };
import { gql, graphql } from "react-apollo";

const mapStateToProps = state => ({
  margin,
  orders: getOrdersAmountByHour(state),
  products: getProductsMap(state),
  variations: getProductsMap(state),
  dailyReportDate: getDailyReportDate(state),
  dailyReportProduct: getDailyReportProduct(state),
  dailyReportVariation: getDailyReportVariation(state)
});

const mapDispatchToProps = dispatch => ({
  handleSetDailyReportDate: date => dispatch(setDailyReportDate(date)),
  handleSetDailyReportProduct: value => dispatch(setDailyReportProduct(value)),
  handleSetDailyReportVariation: value =>
    dispatch(setDailyReportVariation(value))
});

export const DailyAmount = ({
  data,
  dailyReportDate,
  handleSetDailyReportDate,
  products,
  dailyReportProduct,
  handleSetDailyReportProduct,
  dailyReportVariation,
  handleSetDailyReportVariation
}) => {
  if (data.loading) return <div>Loading </div>;
  if (!data.orders) return <div>No hay pedidos </div>;
  const orders = fromJS(data.orders);
  const orderLinesUpdated = orders
    .map(o => o.get("orderLines"))
    .flatten(1)
    .map(ol => ol.get("updatedAt"));
  const daysWithOrders = orders
    .map(o => o.get("createdAt"))
    .concat(orderLinesUpdated)
    .groupBy(date => moment(date).startOf("day"))
    .keySeq()
    .sort((a, b) => (a.isBefore(b) ? 1 : -1));
  let variations = <div />;
  if (dailyReportProduct) {
    variations = (
      <SelectField
        floatingLabelText="Selecciona una variación"
        value={dailyReportVariation}
        onChange={(event, index, value) => handleSetDailyReportVariation(value)}
      >
        <MenuItem value={null} key="" primaryText="" />
        {products
          .find(product => product.get("id") === dailyReportProduct)
          .get("variations")
          .map(variation => {
            return (
              <MenuItem
                value={variation.get("id")}
                key={variation.get("id")}
                primaryText={variation.get("name")}
              />
            );
          })}
      </SelectField>
    );
  }

  return (
    <div>
      <h1>INFORMES</h1>
      <div>
        <h2>Tabla de ventas diaria</h2>
        <SelectField
          floatingLabelText="Selecciona un producto"
          value={dailyReportProduct}
          onChange={(event, index, value) => handleSetDailyReportProduct(value)}
        >
          <MenuItem value={null} key="" primaryText="" />
          {products.map(product => {
            return (
              <MenuItem
                value={product.get("id")}
                key={product.get("id")}
                primaryText={product.get("name")}
              />
            );
          })}
        </SelectField>
        {variations}
        <DailyReportTable
          product={dailyReportProduct}
          variation={dailyReportVariation}
          orders={orders}
        />
      </div>
      <div>
        <h2>Gráficas</h2>
        <SelectField
          floatingLabelText="Selecciona una fecha"
          value={dailyReportDate}
          onChange={(event, index, value) => handleSetDailyReportDate(value)}
        >
          {daysWithOrders.map(option => {
            return (
              <MenuItem
                value={option.format(savedDateFormat)}
                key={option.format(savedDateFormat)}
                primaryText={option.format(savedDateFormat)}
              />
            );
          })}
        </SelectField>
        {dailyReportDate
          ? <div>
              <h3>Ingresos por hora</h3>
              <OrdersByDayBarChart date={dailyReportDate} orders={orders} />
              <h3>Tiempo de producción de un item</h3>
              <OrderLineProcessingTimeByDayChart date={dailyReportDate} />
            </div>
          : null}
      </div>
    </div>
  );
};

const DailyAmountReport = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(DailyAmount);

const Orders = gql`
  query Orders {
    orders {
      id
      delivered
      createdAt
      updatedAt
      orderLines {
        id
        quantity
        unitPrice
        createdAt
        updatedAt
        statusAt
      }
    }
  }
`;
export default graphql(Orders)(DailyAmountReport);



// WEBPACK FOOTER //
// ./src/components/pages/Reports.js